"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serviceIdHeader = exports.clientUserIdHeader = exports.clientSecretHeader = exports.authMethodHeader = exports.authorizationHeader = exports.deviceIdHeader = void 0;
exports.deviceIdHeader = 'tractable-authentication-device-id';
exports.authorizationHeader = 'authorization';
exports.authMethodHeader = 'tractable-authentication-method';
exports.clientSecretHeader = 'tractable-client-authorization';
exports.clientUserIdHeader = 'external-user-id';
exports.serviceIdHeader = 'tractable-service-id';
//# sourceMappingURL=headers.js.map